import { motion } from 'framer-motion';

const SectionHeader = ({ label, title, subtitle, align = 'center', light = false }) => {
  const isCenter = align === 'center';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={isCenter ? 'text-center' : ''}
    >
      {label && (
        <div className={`flex items-center gap-4 mb-4 ${isCenter ? 'justify-center' : ''}`}>
          <span className="h-px w-8 bg-gold/40" />
          <span className={`text-xs font-sans font-medium uppercase tracking-widest-plus ${light ? 'text-gold-light' : 'text-gold'}`}>
            {label}
          </span>
          <span className="h-px w-8 bg-gold/40" />
        </div>
      )}

      {title && (
        <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-serif font-semibold mb-4 ${light ? 'text-white' : 'text-charcoal'}`}>
          {title}
        </h2>
      )}

      <div className={`gold-divider mb-6 ${isCenter ? 'mx-auto' : ''}`} />

      {subtitle && (
        <p className={`max-w-2xl text-base leading-relaxed ${isCenter ? 'mx-auto' : ''} ${light ? 'text-cream-200' : 'text-charcoal/60'}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeader;
